import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useShop } from "../context/ShopContext";
import { inr } from "../lib/api";

const HIDDEN_ON = ["/cart", "/checkout", "/auth", "/admin"];

export default function StickyCartBar() {
  const { cart, cartCount } = useShop();
  const { pathname } = useLocation();
  const show = cartCount > 0 && !HIDDEN_ON.some((p) => pathname.startsWith(p));

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 80 }} animate={{ y: 0 }} exit={{ y: 80 }} className="md:hidden fixed bottom-4 left-4 right-4 z-40" data-testid="sticky-cart-bar">
          <Link to="/cart" className="flex items-center justify-between gap-3 h-14 px-5 rounded-2xl bg-[#1C1917] text-[#FDFBF7] shadow-2xl">
            <span className="flex items-center gap-2 text-sm font-semibold">
              <ShoppingBag size={17} /> {cartCount} item{cartCount > 1 ? "s" : ""} · {inr(cart.subtotal)}
            </span>
            <span className="text-sm font-bold text-[#E0A96D]">View Cart →</span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
